import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Selection {
    doctorId: string;
    appointmentDate: string;
    appointmentId?: number;
    // appointmentTime?: string;
}

@Injectable({ providedIn: 'root' })
export class SelectionService {
    private readonly selection$ = new BehaviorSubject<Selection | null>(null);

    set(selection: Selection) {
        this.selection$.next(selection);
    }

    clear() {
        this.selection$.next(null);
    }

    value(): Selection | null {
        return this.selection$.value;
    }

    changes$ = this.selection$.asObservable();
}